import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

const ConventionalIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41.309"
      height="29.955"
      viewBox="0 0 41.309 29.955"
      y={props.yVal}
      x={props.xVal}
      fill={props.color}
      role="img"
    >
      <title>{t('Conventional Icon')}</title>

      <path
        d="M7.9,41.7a3.714,3.714,0,0,1,2.55,6.415l8.631,10.367a3.5,3.5,0,0,1,1.151-.178,3.684,3.684,0,0,1,2.879,1.371L27.4,57.55a3.661,3.661,0,0,1-.11-.877,3.715,3.715,0,0,1,7.429,0,3.779,3.779,0,0,1-.617,2.056l5.771,6.031a3.638,3.638,0,0,1,1.919-.535A3.715,3.715,0,1,1,38.08,67.94a3.779,3.779,0,0,1,.617-2.056l-5.771-6.031a3.638,3.638,0,0,1-1.919.535,3.684,3.684,0,0,1-2.879-1.371l-4.29,2.125a3.661,3.661,0,0,1,.11.877,3.715,3.715,0,1,1-6.264-2.7L9.066,48.965a3.5,3.5,0,0,1-1.151.178A3.722,3.722,0,0,1,7.9,41.7Z"
        transform="translate(-4.2 -41.7)"
      />
    </svg>
  );
};

export default ConventionalIcon;

ConventionalIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
